// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"76843e8b","513":"af063b5d","787":"dbc4eb61"}[chunkId] + ".chunk.js";
};